import { createAction } from '@reduxjs/toolkit';

export const IN_CALL_CONTACTS_SEARCH_BY_ACTION_TYPE = 'saga/inCallContactsSearchBy';
export const inCallContactsSearchByAction = createAction(IN_CALL_CONTACTS_SEARCH_BY_ACTION_TYPE);
